import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {AdjustmentCreateType} from "../../pages/inventory/adjustment/create/interface";
import {AdjustmentUpdateType} from "../../pages/inventory/inv/history/interface";

const url = "api/inventory/adjustment/";

export async function createAdjustmentCode(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_adjustment_code");
    } catch (err: any) {
        return err?.response;
    }
}

export async function createAdjustment(data: AdjustmentCreateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_adjustment", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateAdjustment(data: AdjustmentUpdateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_adjustment", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadAdjustmentExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_adjustment_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadAdjustmentBarcode(data: { barcode: string }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_adjustment_barcode", data);
    } catch (err: any) {
        return err?.response;
    }
}